import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type DeployNowWorkflowChangeRequestModalProps = {
    workflowId: string;
    workflowName: string;
    workflowChangeRequestStatus: ChangeRequestStatusTypes;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<WorkflowChangeRequest>;
};

export const DeployNowWorkflowChangeRequestModal = (props: DeployNowWorkflowChangeRequestModalProps) => {
    const {
        workflowName,
        onModalClose,
        onSubmitHandler
    } = props;


    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>immediately deploy</b> the Change Request for the Verification Workflow
                    named <b>{workflowName}</b>.</p>
            </div>
        );
    }, []);


    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.SUBMIT}
            title={"Deploy Verification Workflow Change Request"}
            body={bodyElement}
            buttonText={"Deploy Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};